module.exports = __webpack_public_path__ + "static/media/GrabWebIcon-v1.7.0.f227e69c.ttf";